import * as React from "react"
import { cn } from "@/lib/utils/cn"

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          "text-sm font-medium text-slate-700 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 block mb-2",
          className
        )}
        {...props}
      />
    )
  }
)
Label.displayName = "Label"

export { Label }
